import React, { useEffect } from 'react';
import { AboutHero } from '../components/AboutHero';
import { MissionVision } from '../components/MissionVision';
import { StatsSection } from '../components/StatsSection';
import { AboutCTA } from '../components/AboutCTA';
import { Testimonials } from '../components/Testimonials';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { SEO } from '../components/SEO';

export const AboutUs: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <SEO 
        title="About Us - PrintAura"
        description="Learn about PrintAura's commitment to premium mono-carton packaging. Discover our mission, vision, and dedication to sustainable, high-quality packaging solutions."
        keywords="about PrintAura, packaging company, sustainable packaging, mono-carton manufacturer"
        url="https://printaura.co.in/about"
      />
      <AboutHero />
      <MissionVision />
      <StatsSection />
      <AboutCTA />
      <Testimonials />
      <Footer />
    </motion.div>
  );
};
